import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  disable(event) {
    event.target.disabled = true;
  }

  disableAndSubmit(event) {
    const formId = event.target.getAttribute('form');
    const form = document.getElementById(formId);

    if (form) {
      event.target.disabled = true;
      form.submit();
    } else {
      console.error("Form not found.");
    }
  }
}
